<template>
    <div>
        <div class="designeroption" id="frame_style" data-designer-component-id="side_panels">
            <div class="activatepanels">
                <h3>Configure Your Frame</h3>
                <div class="txt">
                    <p>Select your frame configuration by clicking on the switches.</p>
                    <p>Once you select a panel further options will be available.</p>
                </div>

                <div class="options disabled-side">
                    <div class="topbox">
                        <input type="checkbox" value="top" v-model="target.checkedPanels" />
                    </div>
                    <div class="sidepanels">
                        <input type="checkbox" value="left" v-model="target.checkedPanels" :disabled="true"/>
                        <img :src="'/images/activatepanelsimg.jpg'" alt="" class="doorimg"/>
                        <input type="checkbox" value="right" v-model="target.checkedPanels" :disabled="true"/>
                    </div>
                </div>

                <div class="switches">
                    <div class="switchbox" v-show="!(sideIsChecked('left') || sideIsChecked('right'))">
                        <p>Top</p>
                        <input type="checkbox" value="top" v-model="target.checkedPanels" />
                        <span class="status" v-text="sideIsChecked('top') ? 'On' : 'Off'"></span>
                    </div>
                    <div class="switchbox">
                        <p>Left</p>
                        <span class="status">Not Available on Fire Doors</span>
                    </div>
                    <div class="switchbox">
                        <p>Right</p>
                        <span class="status">Not Available on Fire Doors</span>
                    </div>
                </div>

            </div>
        </div>

        <wb-designer-question-frame-style :fabricator="fabricator" :frame-material="frameMaterial" v-model:target="target.frame_id" :checked-panels.sync="target.checkedPanels">

        </wb-designer-question-frame-style>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionSelectFrameStyle from "./DesignerQuestionSelectFrameStyle.vue";

    export default {
        mixins: [
            DesignerQuestionSelectFrameStyle
        ],
        props: {
            frameMaterial: {
                required: false,
                default(){
                    return 3;
                }
            }
        }
    }
</script>
